<template>
  <div class="container-fluid bg-secondary px-0 wow fadeIn" data-wow-delay="0.1s">
    <div class="nav-bar">
      <nav class="navbar navbar-expand-lg bg-primary navbar-dark px-4 py-lg-0">
        <a href="/" class="navbar-brand d-lg-none">
          <img src="/img/logo.png" alt="Safari Strives Logo" style="max-height: 40px; width: auto;">
        </a>
        <a href="/" class="navbar-brand d-none d-lg-block me-4">
          <img src="/img/logo.png" alt="Safari Strives Logo" style="max-height: 50px; width: auto;">
        </a>
        <h4 class="d-lg-none m-0">Menu</h4>
        <button
          type="button"
          class="navbar-toggler me-0"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <div class="navbar-nav me-auto">
            <a href="/" class="nav-item nav-link">
              Home
            </a>
            <router-link
              to="/about"
              class="nav-item nav-link"
              :class="{ active: $route.path === '/about' }"
            >
              About
            </router-link>
            <router-link
              to="/services"
              class="nav-item nav-link"
              :class="{ active: $route.path === '/services' }"
            >
              Services
            </router-link>
            <router-link
              to="/events"
              class="nav-item nav-link"
              :class="{ active: $route.path === '/events' }"
            >
              Events
            </router-link>
            <router-link
              to="/gallery"
              class="nav-item nav-link"
              :class="{ active: $route.path === '/gallery' }"
            >
              Gallery
            </router-link>
            <router-link
              to="/contact"
              class="nav-item nav-link"
              :class="{ active: $route.path === '/contact' }"
            >
              Contact
            </router-link>
          </div>
          <div class="d-none d-lg-flex ms-auto">
            <a class="btn btn-square btn-dark ms-2" href=""><i class="fab fa-twitter"></i></a>
            <a class="btn btn-square btn-dark ms-2" href=""><i class="fab fa-facebook-f"></i></a>
            <a class="btn btn-square btn-dark ms-2" href=""><i class="fab fa-youtube"></i></a>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NavbarView'
})
</script>
